<div *ngIf="myFollowedPages$ | async as result; else loading" class="find-info-saved-pages">

    <hr class="mt-5 mb-5 d-block d-lg-none" />

    <div class="float-left"><i class="fa fa-bookmark accent-2-color"></i></div>

    <div class="float-right">
        <app-action-link [href]="linkToSeeAllSavedPages">
            <span i18n="lnk all saved pages@@lnk-all-saved-pages">All</span><i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
        </app-action-link>
    </div>

    <div class="ml-4 mt-lg-0">
        <h2 class="h6 text-color font-italic" i18n="find information page Saved for later title@@find-information-page-Saved-for-later-title">Saved for later</h2>
        <ul *ngIf="result.length >= 0">
            <li *ngFor="let page of result; let i = index">
                <div class="page-title-wrapper" (mouseenter)="mouseEnter(page)" (mouseleave)="mouseLeave(page)">
                    <div class="page-title-container mb-2 mt-1 mr-6">
                        <a class="link-text-color" href="{{page.Path}}" (focus)="mouseEnter(page)">
                            <span class="page-title">
                                {{page.Title}}
                            </span>
                        </a>
                    </div>
                    <div *ngIf="page.ShowIcon" class="bookmark-icon-container">
                        <button mat-button (click)="removePage($event, page)" (keyup.enter)="removePage($event, page)" (blur)="mouseLeave(page)">
                            <i class="ms-Icon ms-Icon--{{page.Icon}}" i18n-title="@@remove-from-Saved-item" title="Remove from your saved items" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </li>
        </ul>
        <div *ngIf="result.length === 0">
            <p class="mt-4" i18n="no saved pages@@no-saved-pages">You have no saved pages.</p>
        </div>
    </div>

</div>


<ng-template #loading>
    <div>
        <app-widget-placeholder></app-widget-placeholder>
    </div>
</ng-template>
